<template>
  <div>
    <div class="terms-section">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <h2 class="subtitle">Servis</h2>
            <div>
              <p>
                Eurosan d.o.o. garantira da svi proizvodi do roka predaje kupcu posjeduju kvalitetu
                i da su isti bez nedostataka kao i da se mogu koristiti u skladu sa deklariranom
                namjenom, sukladno deklaraciji proizvođača.
              </p>
              <p>
                Kupac je u obavezi da prilikom prijema naručenog proizvoda isti pregleda i utvrdi da
                li ima nedostataka. Ukoliko se nedostaci utvrde isti će biti otklonjeni u garantnom
                roku.
              </p>
              <p>
                Dužina garantnog roka je navedena u garantnom listu, ukoliko proizvod posjeduje
                isti.
              </p>
              <p>
                U slučaju da je proizvod isporučen sa nedostatkom, kupac ima pravo na zamjenu
                istoga.
              </p>
              <p>
                Od reklamacija su izuzeti nedostaci koji su prouzrokovani nestručnim rukovanjem i
                suprotno uputstvu proizvođača za rukovanje proizvodima.
              </p>
              <p>
                Reklamacije proizvoda se priznaju uz predočeni fiskalni račun i ispravno popunjeni
                garantni list kao dokaz kupovine. U slučaju reklamacije proizvoda informacije o
                načinu prijave kvara ili slanju ovla&scaron;tenom servisu informacije potražite na
                garantnom listu isporučenom uz proizvod ili nas
                <strong>kontaktirajte na kontakt telefon 080 080 080 ili putem email adrese </strong
                ><a href="mailto:webshop@eurosan.ba"><strong>webshop@eurosan.ba</strong></a
                ><strong> &nbsp;</strong>
              </p>
              <p>
                Za popravku proizvoda isporučenih od strane Eurosan d.o.o. osigurali smo kvalitetnu
                uslugu kako u garantnom periodu tako i izvan njega. Na&scaron;e osoblje servisa
                stoji vam na raspolaganju za savjete u vezi upotrebe proizvoda, kvarovima te
                mogućnostima popravke istoga.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Service',
  metaInfo() {
    return {
      title: 'Nasi servisi - Eurosan',
      meta: [
        { name: 'description', content: 'Novosti iz svijeta Eurosan grupacije.' },
      ],
    };
  },
};
</script>
